var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"brand",attrs:{"src":"/images/ocularlogo.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }